export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#111111] py-16 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/9087b38339b011a3e90dfeb23d2afa2c/249f0623333fea44c2b2bac063aaf7dc.jpeg"
                alt="Gallery Pizza Logo"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <span className="text-[#FAF8F5] font-bold text-lg tracking-wide leading-none block">GALLERY</span>
                <span className="text-[#FF6B35] font-bold text-lg tracking-wide leading-none block">PIZZA</span>
              </div>
            </div>
            <p className="text-[#8B6F47] text-sm leading-relaxed max-w-xs mb-6">
              Great pizza at the crossroads of South Iceland. Fresh handmade food, warm atmosphere, and art on the walls.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/gallerypizzahvollywood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" },
                { icon: "ri-facebook-line", href: "https://facebook.com/gallerypizza" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-[#FAF8F5]/15 rounded-full text-[#FAF8F5]/50 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-[#FAF8F5] text-xs font-semibold tracking-[0.2em] uppercase mb-5">Quick Links</p>
            <div className="flex flex-col gap-3">
              {[
                { label: "Menu", href: "#menu" },
                { label: "Stop Here", href: "#stop-here" },
                { label: "Locations", href: "#locations" },
                { label: "Photos", href: "#photos" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <button
                  key={link.label}
                  onClick={() => handleNav(link.href)}
                  className="text-[#8B6F47] text-sm hover:text-[#FF6B35] transition-colors duration-200 cursor-pointer text-left whitespace-nowrap"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <p className="text-[#FAF8F5] text-xs font-semibold tracking-[0.2em] uppercase mb-5">Contact</p>
            <div className="flex flex-col gap-4">
              <div>
                <p className="text-[#FAF8F5]/40 text-xs uppercase tracking-widest mb-1">Location</p>
                <p className="text-[#8B6F47] text-sm">Landvegamót, Route 1</p>
                <p className="text-[#8B6F47] text-sm">851 Hella, Iceland</p>
              </div>
              <div>
                <p className="text-[#FAF8F5]/40 text-xs uppercase tracking-widest mb-1">Phone</p>
                <a href="tel:+3544878440" className="text-[#8B6F47] text-sm hover:text-[#FF6B35] transition-colors">+354 487 8440</a>
              </div>
              <div>
                <p className="text-[#FAF8F5]/40 text-xs uppercase tracking-widest mb-1">Hours</p>
                <p className="text-[#8B6F47] text-sm">Open Daily: 11:30 – 21:00</p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#FAF8F5]/8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#FAF8F5]/30 text-xs">
            &copy; 2024 Gallery Pizza Landvegamót. All rights reserved.
          </p>
          <p className="text-[#FAF8F5]/20 text-xs">
            Landvegamót &bull; Hella &bull; South Iceland
          </p>
        </div>
      </div>
    </footer>
  );
}
